/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Typography } from "@mui/material";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";
import { useGetCurrentWebpage } from "hooks/useGetCurrentWebpage";
// Warning: Using display in edit
import { NavigationListSection } from "cms/components/components/navigation-list/display/section-list";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";

function NavigationListComponentEditor () {
    
    const webpage = useGetCurrentWebpage();
    const { component, updateFactory } = useUpdateComponent();
    
    const onChangeDescription = updateFactory("description");

    return (
        <div className='simplicity-editor-frame'>
            <Typography variant='overline' color={"text.secondary"}>
                Description:{" "}
            </Typography>
            <SimplicityComposerEnsureTipTap
                richtext={component.description}
                onChange={onChangeDescription}
            />
            {/* Display Navigation Tree - not editable */}
            <NavigationListSection
                webpage_id={webpage?.guid}
            />
            <div style={{ padding: "0 2em" }}>
                <Typography variant='body2' color='text.secondary'>
                    (Sections List Nav Component is generated on the client by getting two levels of child navigation
                    items, based on this page in the navigation tree. You can see this in Preview.)
                </Typography>
            </div>
        </div>
    );
}

NavigationListComponentEditor.displayName = "NavigationListComponentEditor";
export { NavigationListComponentEditor };
